import './Countdown.less';
import React, {useEffect, useState} from "react";
import {getCountdown, getCountdownTime} from './util';
import __ from "../../../i18n";


export default function Countdown({
    endTime = null,
}) {
    const [countdownTime, setCountdownTime] = useState(getCountdownTime(endTime));
    useEffect(() => {
        const intervalId = window.setInterval(() => {

            setCountdownTime(countdownTime => {
                const newTime = countdownTime - 1000;

                if (newTime <= 0) {
                    window.clearInterval(intervalId);
                    return null;
                }

                return newTime;
            });
        }, 1000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, []);

    if (countdownTime === null) {
        return null;
    }

    const {hours, minutes, seconds} = getCountdown(countdownTime);

    return (
        <div className="Countdown">
            {__('promotion_end_after{hours,minutes,seconds}', {
                hours,
                minutes,
                seconds
            })}
        </div>
    )
}
